import styled, { css, keyframes } from 'styled-components'
import { COLORS } from 'consts/colors'

// Sits over the (empty) prompt editor. Font metrics and padding mirror
// common-components/TextAreaInput so the fake typing lines up with where real
// input would appear.
export const Overlay = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  pointer-events: none;
  overflow: hidden;
  color: ${COLORS.secondary};
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`

const blink = keyframes`
  0%, 50% {
    opacity: 1;
  }
  50.1%, 100% {
    opacity: 0;
  }
`

export const Caret = styled.span<{ $isBlinking?: boolean }>`
  display: inline-block;
  width: 1px;
  height: 1em;
  margin-left: 2px;
  vertical-align: text-bottom;
  background-color: currentColor;

  ${({ $isBlinking }) =>
    $isBlinking &&
    css`
      animation: ${blink} 1s infinite;
    `}
`
